import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class MonitoringService {
    private renderer: Renderer2

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private rendererFactory: RendererFactory2
    ) {
        this.renderer = this.rendererFactory.createRenderer(null , null)
    }


    loadScript() {
        const dynatraceUrl = environment.dynatraceUrl;
        if (dynatraceUrl) {
            const script = this.renderer.createElement('script')
            this.renderer.setAttribute(script, 'src', dynatraceUrl);
            this.renderer.setAttribute(script, 'type', 'text/javascript')
            this.renderer.appendChild(this.document.head, script)
        }
    }
}